export default "__VITE_ASSET__BsAIFLEO__"